import { createLoader } from '@spotify-internal/creator-data-loading';
import { webgateFetchJson, IDENTITY_API } from '../../shared/lib/api';
import type { ArtistProfile, ArtistProfileResource } from './types';

function transform(
  artistProfileResource: ArtistProfileResource,
): ArtistProfile | null {
  return !artistProfileResource
    ? null
    : {
        ...artistProfileResource,
        artistPick: artistProfileResource.pinnedItem,
        artistFundraisingPick: artistProfileResource.fanFunding,
        catalog: artistProfileResource.releases,
        gallery:
          (artistProfileResource.gallery &&
            artistProfileResource.gallery.images &&
            artistProfileResource.gallery.images.map(image => ({
              id: image.originalId,
              src: image.image.uri,
            }))) ||
          [],
        gallerySource:
          artistProfileResource.gallery &&
          artistProfileResource.gallery.gallerySource,

        headerImage: {
          header:
            (artistProfileResource.header &&
              artistProfileResource.header.uri) ||
            '',
          avatar:
            (artistProfileResource.avatar &&
              artistProfileResource.avatar.uri) ||
            '',
        },
        isEditable: artistProfileResource.isEditable ?? false,
        playlists: artistProfileResource.playlists || { data: [] },
        topTracks: artistProfileResource.topTracks || [],
      };
}

const artistProfileFields = [
  'artistUri',
  'autobiography',
  'avatar',
  'biography',
  'concertsMetadata',
  'fallbackHeader',
  'gallery',
  'header',
  'isVerified',
  'mergedUserUri',
  'monthlyListeners',
  'name',
  'newRelease',
  'pinnedItem',
  'playlists',
  'relatedArtists',
  'releases',
  'topTracks',
  'isEditable',
  'fanFunding',
];

export const artistProfileLoader = createLoader<string, ArtistProfile | null>(
  async (artistId: string) => {
    const endpoint = `${IDENTITY_API}/v2/profile/${artistId}?fields=${artistProfileFields}&application=s4a&imgSize=large`;
    return transform(await webgateFetchJson(endpoint));
  },
);

// To be used to update values for the currently loaded artist
export const updateProfileField = async (
  artistId: string,
  fieldsToUpdate: Partial<ArtistProfile>,
) => {
  // This profile value should only ever come from the cache
  const profile = await artistProfileLoader.load(artistId);
  if (!profile) {
    return;
  }
  artistProfileLoader.clear(artistId).prime(artistId, {
    ...profile,
    ...fieldsToUpdate,
  });
};
